import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/tables/Icon';
import { getGameType, gamePlayUrlPrefix } from '../../variables/gameTypes';

// Games tab: every Grid (game instance), across all 4 types, as a card grid
// instead of the old 4 separate type-specific list pages.
export default function GamesTab({ search, typeFilter, refresh, onEdit }) {
   const navigate = useNavigate();
   const [games, setGames] = useState([]);
   const [cardCounts, setCardCounts] = useState({});
   const [localRefresh, setLocalRefresh] = useState(0);

   useEffect(() => {
      axios.get('/api/grid', { withCredentials: true })
         .then(response => setGames(response.data || []))
         .catch(err => { if(err.response && err.response.status === 401) navigate('/login'); });
      axios.get('/api/gridcard', { withCredentials: true })
         .then(response => {
            const counts = {};
            (response.data || []).forEach(card => {
               if(card.grid && card.grid.id) counts[card.grid.id] = (counts[card.grid.id] || 0) + 1;
            });
            setCardCounts(counts);
         })
         .catch(() => {});
   }, [refresh, localRefresh, navigate]);

   const bump = () => setLocalRefresh(prev => prev + 1);

   const visibleGames = useMemo(() => {
      const query = (search || '').trim().toLowerCase();
      return games
         .filter(g => !typeFilter || Number(g.type) === Number(typeFilter))
         .filter(g => !query || (g.name || '').toLowerCase().includes(query))
         .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
   }, [games, search, typeFilter]);

   if(visibleGames.length === 0) {
      return <div className="games-empty">Ігор не знайдено</div>;
   }

   return (
      <div className="games-grid">
         {visibleGames.map(game => {
            const gameType = getGameType(game.type);
            const clearurl = gamePlayUrlPrefix(game.type);
            return (
               <div key={game.id} className="game-card" style={{ '--accent': gameType.accent }}>
                  <div className="game-card-body" onClick={() => navigate('/games/' + game.id)}>
                     <span className="game-card-type-badge">{gameType.label}</span>
                     <div className="game-card-name">{game.name}</div>
                     <div className="game-card-count">{cardCounts[game.id] || 0} елементів</div>
                  </div>
                  <div className="game-card-actions" onClick={e => e.stopPropagation()}>
                     <Icon mode="edit" id={game.id}
                        stateHundler={(state, id) => { if(state === 'edit') onEdit(id); }}
                        className="icon-edit" classes="icon-dimensions-mid" />
                     <Icon mode="copy-url" clearurl={clearurl} item={game} headers={{ urlfield: 'id' }}
                        className="icon-copyurl" classes="icon-dimensions-mid" />
                     <Icon mode="copy-iframe" clearurl={clearurl} item={game}
                        className="icon-copyframe" classes="icon-dimensions-mid" />
                     <Icon mode="delete" url={'/api/grid/' + game.id} onRefreshHundler={bump}
                        className="icon-delete" classes="icon-dimensions-mid" />
                  </div>
               </div>
            );
         })}
      </div>
   );
}
